import * as React from 'react';

import XapiContextProvider from 'bundles/enterprise-admin-xapi/components/XapiContextProvider';
import WithBusinessHeader from 'bundles/enterprise-admin-xapi/components/layout/WithBusinessHeader';

const XApiFormsWrapper = ({ children, ...props }: $TSFixMe) => (
  <WithBusinessHeader {...props}>
    <XapiContextProvider {...props}>{children}</XapiContextProvider>
  </WithBusinessHeader>
);

export default XApiFormsWrapper;
